import taxes from "./taxes"
import deductions from "./deductions"
import tax from "./tax"
import credits from "./credits"

export default tax({ ...taxes, ...deductions, ...credits })